export function getIndustryKey(industry = "") {
    return String(industry || "").trim();
}

export function getIndustryPreviewConfig(form = {}, previewSeed = null) {
    const businessName =
        form.businessName?.trim() ||
        previewSeed?.businessName?.trim() ||
        "Your Business";

    const industry =
        getIndustryKey(form.industry) ||
        getIndustryKey(previewSeed?.industry) ||
        "Business";

    const fallbackDescription =
        `Premium ${industry.toLowerCase()} solutions designed to build trust, drive leads, and create a stronger digital presence.`;

    const shared = {
        businessName,
        industry,
        goal: form.goalOfWebsite || "Generate Leads",
        brandStyle: form.brandStyle || "Premium"
    };

    const configMap = {
        "Real Estate": {
            headline: `${businessName} — trusted property solutions for modern buyers and investors`,
            subtitle:
                form.description?.trim() ||
                "Showcase listings, highlight locations, build trust, and turn property interest into qualified leads with a premium real-estate-first website experience.",
            primaryCta: "View Properties",
            secondaryCta: "Talk to Advisor",
            pages:
                Array.isArray(form.pages) && form.pages.length > 0
                    ? form.pages.slice(0, 4)
                    : ["Home", "Listings", "Localities", "Contact"],
            visualType: "real-estate",
            chips: ["Buy", "Rent", "Ahmedabad"]
        },

        Academy: {
            headline: `${businessName} — programs, coaching, and growth-driven admissions`,
            subtitle:
                form.description?.trim() ||
                "Present programs, coaches, achievements, and admissions in a way that builds credibility and increases student interest from the first impression.",
            primaryCta: "Explore Programs",
            secondaryCta: "Meet Our Coaches",
            pages:
                Array.isArray(form.pages) && form.pages.length > 0
                    ? form.pages.slice(0, 4)
                    : ["Home", "Programs", "Coaches", "Admissions"],
            visualType: "academy",
            chips: ["Programs", "Coaches", "Admissions"]
        },

        Healthcare: {
            headline: `${businessName} — patient-first care with a modern digital experience`,
            subtitle:
                form.description?.trim() ||
                "Create a clean, trustworthy healthcare experience designed for appointments, service clarity, and stronger patient confidence.",
            primaryCta: "Book Appointment",
            secondaryCta: "View Services",
            pages:
                Array.isArray(form.pages) && form.pages.length > 0
                    ? form.pages.slice(0, 4)
                    : ["Home", "Services", "Doctors", "Appointments"],
            visualType: "healthcare",
            chips: ["Appointments", "Doctors", "Services"]
        },

        Legal: {
            headline: `${businessName} — trusted legal expertise with a strong consultation-first presence`,
            subtitle:
                form.description?.trim() ||
                "Build authority with a structured legal website focused on trust, consultations, service clarity, and a more professional digital presence.",
            primaryCta: "Book Consultation",
            secondaryCta: "View Practice Areas",
            pages:
                Array.isArray(form.pages) && form.pages.length > 0
                    ? form.pages.slice(0, 4)
                    : ["Home", "Practice Areas", "About", "Consultation"],
            visualType: "legal",
            chips: ["Consultation", "Cases", "Trust"]
        },

        SaaS: {
            headline: `${businessName} — a product-led digital experience built to convert and scale`,
            subtitle:
                form.description?.trim() ||
                "Launch a high-converting SaaS experience with stronger product storytelling, feature communication, onboarding clarity, and growth-focused sections.",
            primaryCta: "Start Free Trial",
            secondaryCta: "See Features",
            pages:
                Array.isArray(form.pages) && form.pages.length > 0
                    ? form.pages.slice(0, 4)
                    : ["Home", "Features", "Pricing", "Contact"],
            visualType: "saas",
            chips: ["Features", "Pricing", "Dashboard"]
        }
    };

    const picked = configMap[industry];

    if (picked) {
        return {
            ...shared,
            ...picked
        };
    }

    return {
        ...shared,
        headline:
            form.businessName && form.industry
                ? `${form.businessName} — ${form.industry} website experience`
                : form.businessName
                    ? `${form.businessName} — premium website preview`
                    : "Your AI-generated website preview starts here",
        subtitle: form.description?.trim()
            ? form.description
            : form.industry
                ? `A premium, conversion-focused ${form.industry.toLowerCase()} website experience built with Shriansh Nexus.`
                : fallbackDescription,
        primaryCta: "Get Started",
        secondaryCta: "Learn More",
        pages:
            Array.isArray(form.pages) && form.pages.length > 0
                ? form.pages.slice(0, 4)
                : ["Home", "About", "Services", "Contact"],
        visualType: "generic",
        chips: ["Services", "About", "Contact"]
    };
}